import { Button, Form, Input, InputNumber, Select } from "antd";
import { filterOption, fiscalCodeField, requiredField } from "../common/common";
import { useEffect, useState } from "react";
import axiosInstance from "../common/api";
import { useNavigate } from "react-router";

export default function () {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const onFinish = (data) => {
    setLoading(true);
    axiosInstance
      .post("doctor", data)
      .then(() => navigate(-1))
      .finally(() => setLoading(false));
  };

  return (
    <Form onFinish={onFinish} layout="vertical" autoComplete="off">
      <Form.Item label="Nome" rules={[requiredField]} name="firstName">
        <Input />
      </Form.Item>
      <Form.Item label="Cognome" rules={[requiredField]} name="lastName">
        <Input />
      </Form.Item>
      <Form.Item label="Codice fiscale" name="fiscalCode" rules={[fiscalCodeField]}>
        <Input />
      </Form.Item>
      <Form.Item
        label="E-mail"
        name="email"
        rules={[{ type: "email", message: "E-mail non valida" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Numero di telefono"
        name="phoneNumber"
        rules={[
          { pattern: /^[0-9].{9}$/, message: "Numero non valido. Rimuovere eventuali spazi" },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Conferma
        </Button>
      </Form.Item>
    </Form>
  );
}
